import { Stack, styled } from '@chronosphereio/chrono-ui';
import { TimeZoneAutocomplete } from '../../TimeZoneAutocomplete';

export interface TimeZoneSectionProps {
  userTimeZone?: string;
  setTimeZone?: (timeZone: string) => void;
  timeZone: string;
  disableTimeZoneOverride?: boolean;
}

/**
 * Time zone selection component. Extracted as a separate component to prevent
 * remounting on parent re-renders, which would cause loss of internal state
 * (e.g., dropdownOpen) in TimeZoneAutocomplete.
 */
export function TimeZoneSection({
  userTimeZone,
  setTimeZone,
  timeZone,
  disableTimeZoneOverride,
}: TimeZoneSectionProps) {
  if (!userTimeZone || !setTimeZone) {
    return null;
  }

  return (
    <TimeZone>
      <TimeZoneAutocomplete
        align="left"
        showAccountTimeZone={true}
        userTimeZone={userTimeZone}
        timeZone={timeZone}
        disabled={disableTimeZoneOverride}
        onChange={(zone) => {
          setTimeZone(zone);
        }}
      />
    </TimeZone>
  );
}

const TimeZone = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.popover,
}));
